import { useH5Mock } from "../global/GlobalMock";
import { post } from "../utils/Backend";
import { mockCreateOrder, mockGetMyOrderDetail, mockListMyOrders } from "./StoreOrderMock";
import type {
  CancelStoreOrderResult,
  CreateStoreOrderResult,
  ListMyOrdersQuery,
  ListMyStoreOrdersResult,
  MyStoreOrderDetailResult,
  QueryPayStatusResult,
} from "./StoreOrderType";

/** 关闭店铺订单 mock 时保持 `&& false`（见 frontend-data-mock-rule）。 */
const mockStoreOrder = false;

export const StoreOrderApi = {
  createOrder: (p: {
    spaceId: string;
    spaceProductId: string;
    serviceTier: string;
    subProductItemId?: string;
    upgradeFromSpaceProductId?: string;
  }): Promise<CreateStoreOrderResult | string> => {
    if (useH5Mock && mockStoreOrder) {
      return Promise.resolve(mockCreateOrder(p));
    }
    return post<typeof p, CreateStoreOrderResult>("/lark/app/storeOrder/create", p);
  },
  signAgreement: (p: {
    spaceId: string;
    spaceProductId: string;
    templateId: string;
  }): Promise<unknown | string> =>
    post<typeof p, unknown>("/lark/app/storeOrder/signProductAgreement", p),
  listMyOrders: (p: ListMyOrdersQuery): Promise<ListMyStoreOrdersResult | string> => {
    if (useH5Mock && mockStoreOrder) {
      return Promise.resolve(mockListMyOrders(p));
    }
    return post<typeof p, ListMyStoreOrdersResult>("/lark/app/storeOrder/listMyOrders", p);
  },
  getMyOrderDetail: (p: { spaceId: string; orderId: string }): Promise<MyStoreOrderDetailResult | string> => {
    if (useH5Mock && mockStoreOrder) {
      return Promise.resolve(mockGetMyOrderDetail(p));
    }
    return post<typeof p, MyStoreOrderDetailResult>("/lark/app/storeOrder/getMyOrderDetail", p);
  },
  queryPayStatus: (p: { spaceId: string; orderId: string }): Promise<QueryPayStatusResult | string> =>
    post<typeof p, QueryPayStatusResult>("/lark/app/storeOrder/queryPayStatus", p, { silent: true }),
  cancelOrder: (p: { spaceId: string; orderId: string }): Promise<CancelStoreOrderResult | string> =>
    post<typeof p, CancelStoreOrderResult>("/lark/app/storeOrder/cancelOrder", p),
};
